import _      from 'lodash'
import moment from 'moment'
import 'moment-duration-format'

import Model from 'alto-orm/lib/orm/model'

timeFormat = 'HH:mm:ss'

export default class CourseGroup extends Model
  # attrs: name (string), displayName (string), orderNumber (positive smallint),
  #        servedAt (time), lockBefore (duration)

  @primaryKey: 'name'

  @nominativeName: 'skupina chodů'
  @accusativeName: 'skupinu chodů'

  @serialize: (course) ->
    _.assign(super(course), served_at:   course.servedAt.format(timeFormat), \
                            lock_before: course.lockBefore.toISOString())

  @deserialize: (row) ->
    super(row).with(servedAt:   moment.duration(row.served_at, timeFormat), \
                    lockBefore: moment.duration(row.lock_before))

  # these expect date as start-of-day moment
  servedAtOn: (date) ->
    date.clone().add(@servedAt)
